module.exports = __webpack_public_path__ + "static/img/2.8a3d724.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/2.jpg
// module id = Z6QS
// module chunks = 12